import React, { Component } from 'react';
import { FormGroup,Row,FormControl } from 'react-bootstrap';
import validations from '../../Helper/Validations';
import './signup.css';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {fetchSuggestions,registerAction} from '../../Actions';
import Logo from '../../Helper/Logo/logo';
import Back from "../../Helper/Back/back";
import axiosI  from '../../Service/service';
import {routeName} from '../../../src/Service/env';
import Alert from '../../Helper/SimpleAlert/alert';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import * as constants from '../../Constants';

const styles={
    Button: {
        color: '#fff',
        borderRadius: '5px',
        fontSize:'medium',
        marginBottom:'3%',
        textTransform:'none'
    },
    disabledButton: {
        color: '#fff',
        borderRadius: '5px',
        fontSize:'medium',
        marginBottom:'3%',
        textTransform:'none',
        opacity:0.6,
        '&:hover':{
            backgroundColor:'#851679',
            opacity:0.6,
            cursor:'auto'
        }
    },
};


class SecuritySection extends Component {
    constructor(props){
        super(props);
        this.state={
            lblErrorMsg:'',
            lblPasswordMsg:'',
            data:{},
            suggestions:'',
            showError:false,
            msg:''
        }
    }

    componentWillMount(){
        if (this.props.data) {
            const {data} = this.props;
            if (Object.keys(data).length > 0) {
                this.setState({
                    data
                })
            }
        }
       this.props.fetchSuggestions(this.props.data);
    }

    handleChange=(e)=>{
        let { name, value } = e.target;
        const { data } = this.state;
        if(name === 'Username'){
            value = value.replace('@','');
            let msg=validations.validateUserName(value);
            if(!value.includes('@')) {
                value = `@${value}`;
            }
            this.setState({
                lblErrorMsg: msg
            });
        }
        if(name==="Password"){
            let msg=validations.validatePassword(value);
            this.setState({
                lblPasswordMsg: msg
            });
        }
        data[name]=value;
        this.setState({data})
    };

    alertCallback=()=>{
        this.setState({
            showError:false
        })
    };

    onPrevious=()=>{
        this.props.onPrevious(this.state.data);
    };

    verifyAccountUserName = () => {
        let { data, lblErrorMsg } = this.state;
        let username = data.Username;
        if(data.Username && data.Username!=='') {
            data.Username = data.Username && data.Username.replace('@','');
            axiosI.post(constants.API.verifyAccountUsernameApi,{ContactNo:this.props.data.PhoneNo.trim(),EmailId:this.props.data.Email.trim(),Username:this.state.data.Username.trim(),Name:this.props.data.Name.trim()}).then((response) => {
                if (response.data.results.Message === 'username exist') {
                    lblErrorMsg= 'Username Already Exist';
                }
                else if(data.Username.replace('@','').length < 4) {
                    lblErrorMsg= 'User name must be greater than 3 characters.';
                }
                else if(data.Username.replace('@','').length > 15) {
                    lblErrorMsg=  'User name must have 15 characters or less.';
                }
                else {
                    lblErrorMsg= '';
                }
                data.Username = username;
                this.setState({ ...data, lblErrorMsg });
            });
        }
    };

    fillText=(value)=>()=>{
        let { data } = this.state;
        let lblErrorMsg
        data.Username=`@${value}`;
        lblErrorMsg="";
        this.setState({ ...data, lblErrorMsg })
    };

    checkEmpty=()=>{
        const { data,lblErrorMsg, lblPasswordMsg } = this.state;
        return(data.Username!==undefined && data.Username!=="" && data.Password!==undefined &&
        data.password!=="" && lblErrorMsg==="" && lblPasswordMsg==='')
    };

    onSubmit=()=>{
        if(this.checkEmpty()) {
            let userName = this.state.data.Username.replace('@', "");
            axiosI.post(constants.API.verifyAccountUsernameApi,{ContactNo:this.props.data.PhoneNo.trim(),EmailId:this.props.data.Email.trim(),Username:userName.trim(),Name:this.props.data.Name.trim()}).then(({data}) => {
                if (data.results.Message === 'username exist') {
                    this.setState({
                        lblErrorMsg: 'Username Already Exist'
                    });
                }
                else {
                    this.setState({
                        lblErrorMsg: ''
                    });
                    let newUserName = this.state.data.Username.replace('@','');
                    this.props.registerAction({...this.state.data, Username: newUserName.trim()}).then((data) => {
                        if (data.results.ResponseCode)
                            this.props.history.push({pathname: `/${routeName}/Payment`, state: {Business: data,withTrial:true}});
                        else {
                            this.setState({
                                showError: true,
                                msg: data.results.Message
                            })
                        }
                    }).catch(() => {
                        this.setState({
                            showError: true,
                            msg: 'Error in Registration'
                        })
                    });
                }
            });
        }
    };

    render(){
        const { lblErrorMsg, data, lblPasswordMsg } = this.state;
        const {classes} = this.props;
        return(
            <section className="container">
                <Alert onClose={this.alertCallback} showSuccess={false} showError={this.state.showError} Msg={this.state.msg}/>
                <Row>
                    <div className="col-12 text-center">
                        <Back onPrevious={this.onPrevious}/>
                        <Logo/>
                    </div>
                    <div className="col-12">
                        <h2 className='subHeading'>Create new login</h2>
                        <input type={'hidden'} value=""/>
                        <div className="error">
                            {
                                (lblErrorMsg!=='' || lblPasswordMsg!=='')?<span>{lblErrorMsg ? lblErrorMsg :lblPasswordMsg}</span>:<span/>
                            }
                        </div>
                        <FormGroup>
                            <FormControl type={'text'} placeholder="New Username" name="Username" autocomplete="off"
                                         onChange={this.handleChange}
                                         value={data.Username}
                            />
                            <div className='suggestion-div'>
                                Suggestions
                                : {this.props.suggestions.results && this.props.suggestions.results.Suggestions.map((suggestion)=>{
                                    return(
                                        <a onClick={this.fillText(suggestion)}>@{suggestion}</a>
                                    )
                            })}
                            </div>
                        </FormGroup>
                        <FormGroup>
                            <FormControl type={'Password'} placeholder="New Password" name="Password"
                                         autoComplete="off"
                                         onChange={this.handleChange}
                                         value={data.Password}
                            />
                        </FormGroup>
                        <FormGroup className="text-right mt-50">
                            <Button className={(this.checkEmpty()) ? classes.Button:classes.disabledButton}
                                    color={'primary'}
                                    variant={'contained'}
                                    onClick={this.onSubmit}>Next</Button>
                        </FormGroup>
                    </div>
                </Row>
            </section>
        )
    };
}
const mapStateToProps=(state)=> {
    return{
        suggestions:state.suggestions
    }
};
const matchDispatchToProps=(dispatch)=> {
    return bindActionCreators({
        fetchSuggestions,
        registerAction
    },dispatch)
};
export default connect(mapStateToProps,matchDispatchToProps)(withStyles(styles)(SecuritySection));